/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var PaintEffectType;
(function (PaintEffectType) {
    PaintEffectType["Metallic"] = "Metallic";
    PaintEffectType["Matte"] = "Matte";
    PaintEffectType["Pearlescent"] = "Pearlescent";
})(PaintEffectType || (PaintEffectType = {}));
export function PaintEffectTypeFromJSON(json) {
    return PaintEffectTypeFromJSONTyped(json, false);
}
export function PaintEffectTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function PaintEffectTypeToJSON(value) {
    return value;
}
